import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
   FormGroup,
   Label,
} from 'reactstrap';

import {
   allHackmotionReport,
   deleteHackmotionReport,
   allStudents,
   addHackmotionReport,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import AddItem from './component/addform';
import EditForm from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class hackmotionreport extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         adddiv: false,
         editdiv2: false,
         reportdiv: false,
         selectedFile: [],
         seldate: '',
         student: '',
         allreports: [],
         filecnt: 0,
         heightProportion: 1600,
         widthProportion: 500
      };

      this.onBackSection = this.onBackSection.bind(this);
      this.deleteForm = this.deleteForm.bind(this);

   }

   UNSAFE_componentWillMount() {
      this.props.allHackmotionReport();
      this.props.allStudents();
   }

   selstudent = (evt) => {
      var stdid = evt.value;
      this.setState({ student: stdid });
   }

   selectdate = (date) => {
      const seldate = moment(new Date(date)).format('yyyy-MM-DD');
      this.setState({ seldate: date });

   }

   onAddSession() {
      this.setState({
         viewdiv: false,
         reportdiv: false,
         adddiv: true,
      });
   }

   onBackSection() {
      this.setState({
         adddiv: false,
         reportdiv: false,
         viewdiv: true,
         editdiv2: false,
      });
   }


   editAssessment(assval) {
      var allfiles = assval.tsr_filename;
      var flesplt = allfiles.split(',');
      var filecnt = flesplt.length;
      this.setState({
         allreports: flesplt,
         filecnt: filecnt
      });

      this.setState({
         viewdiv: false,
         adddiv: false,
         reportdiv: true,
      });
   }

   editAssessment2(assval) {
      var allfiles = assval.tsr_filename;
      var flesplt = allfiles.split(',');
      var filecnt = flesplt.length;
      this.setState({
         allreports: flesplt,
         filecnt: filecnt
      });

      this.setState({
         viewdiv: false,
         adddiv: false,
         reportdiv: false,
         editdiv2: true
      });
   }


   deleteForm(data) {
      this.data = data;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {

      if (popupResponse) {
         this.props.deleteHackmotionReport(this.data);
         this.data = ""
      }
   }


   render() {
      const { match, hackmotionreportlist, studentlists, loading } = this.props;

      const allstudent = studentlists.map((stdval) => {
         return {
            label: stdval.student,
            value: stdval.uudID
         }
      });

      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };

      const columns = [
         { name: "no", label: "NO" },
         { name: "name", label: "NAME" },
         { name: "cdate", label: "DATE" },
         { name: "report", label: "REPORT NAME" },
         { name: "action", label: "REPORT" },
         { name: "action1", label: "ACTION1" },

      ];
      const tabledata = Array.isArray(hackmotionreportlist) ? hackmotionreportlist.map((assmntval, idx) => {
         const flbtn = <a onClick={() => this.editAssessment(assmntval)}><span className="badge badge-info" >View</span></a>;
         const editBtn = (
            <IconButton className="text-info" aria-label="edit" onClick={() => this.editAssessment2(assmntval)}><EditOutlinedIcon/></IconButton>
         );
         const deleteBtn = (
            <IconButton
               className="text-danger"
               aria-label="Remove"
               onClick={() => this.deleteForm(assmntval.tsrID)}
            >
               <DeleteOutlineOutlinedIcon/>
            </IconButton>
         );

         return {
            no: idx + 1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            report: assmntval.tsr_reportname,
            action: flbtn,
            action1: (
               <div>
                  {editBtn} {deleteBtn}
               </div>
            ),

         }
      }) : [];

      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>HACKMOTION SESSION | {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.hackmotionreport" />} match={match} />

            {this.state.viewdiv &&
               <div className="col-sm-12 col-md-12">
                  <RctCollapsibleCard heading="List" fullBlock>
                     <MUIDataTable
                        title={<div><Button onClick={() => this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Report</Button></div>}
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            }
            {this.state.adddiv &&
               <AddItem onClick={this.onBackSection} data={this.state}/>
            }
             {this.state.editdiv2 &&
               <EditForm onClick={this.onBackSection} data={this.state}/>
            }

            {this.state.reportdiv &&
               <div>
                  <div className="row">
                     <div className="col-md-12" ref={this.nodeRef}>
                        <CarouselProvider
                           naturalSlideWidth={this.state.widthProportion}
                           naturalSlideHeight={this.state.heightProportion}
                           totalSlides={this.state.filecnt}
                        >
                           <div className="sdfsdf">
                              <div className="dflf">
                                 <button type="button" className="mr-10 mb-10 btn btn-outline-warning " onClick={this.onBackSection}>Back</button>
                              </div>
                              <div className="text-center" style={{ marginTop: "-30px" }}>
                                 {this.state.allreports.map((uptval, idx) => (
                                    <Dot className="text-center" slide={idx} >{idx + 1}</Dot>
                                 ))}
                              </div>
                           </div>
                           <Slider>
                              {this.state.allreports.map((uptval, idx) => (
                                 <Slide index={idx}>
                                    <RctCollapsibleCard>
                                       <iframe src={AppConfig.apiurl + '/theme/img/hackmotion/' + uptval} width="100%" height={600} ></iframe>
                                    </RctCollapsibleCard>
                                 </Slide>
                              ))}
                           </Slider>
                        </CarouselProvider>

                     </div>
                  </div>
               </div>
            }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'Hackmotion monitor report'}
            />

         </div>
      )
   }
}

const mapStateToProps = ({ hackmotionreport, mostlyused }) => {
   const { hackmotionreportlist, loading } = hackmotionreport;
   const { studentlists } = mostlyused;
   return { hackmotionreportlist, studentlists, loading };
}

export default connect(mapStateToProps, {
   allHackmotionReport,
   allStudents,
   deleteHackmotionReport,
   addHackmotionReport
})(hackmotionreport); 